import React, { HTMLAttributes } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import Infused from "./cell/infused"
import Diversified from "./cell/Diversified"
import Social from "./cell/social";
import Business from "./cell/business";
import Community from "./cell/community"
import Partners from "./cell/partners"

// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
  // const t = useTranslation();
  // const {isLogin} = store.user;

  return (
    <div className={cx(styles.main, className)}>
      <Infused />
      <Diversified />
      <Social />
      <Business />
      <Community />
      <Partners />
    </div>
  );
};

export default observer(Main);
// export default Main;
